let BASE_URL = ""
let WS_URL = ""  // websocket地址
let FLV_URL = '' // 视频流地址
const TIMEOUT = 10000


if (process.env.NODE_ENV === 'development') {
    BASE_URL = '/localApi' 
    
    // BASE_URL = 'https://api.obtdata.com/haiou-feiche/'

    // WS_URL =   'ws://192.168.1.120:7774/websocket/data_analysis/info'
    //https://yun.seagull-flyingcar.com/haiou-feiche/
    //wss://api.obtdata.com/haiou-feiche/websocket/data_analysis/info
    WS_URL = 'wss://yun.seagull-flyingcar.com/haiou-feiche/websocket/data_analysis/info'
    //https://web17.obtdata.com/live?port=1999&app=liveapp&stream=test&token=
    //https://yun.seagull-flyingcar.com/live?port=1999&app=liveapp&stream=test&token=
    FLV_URL = 'https://yun.seagull-flyingcar.com/live?port=1999&app=liveapp&stream=test&token='
} else if (process.env.NODE_ENV === 'production') {
    BASE_URL = 'https://yun.seagull-flyingcar.com/haiou-feiche/'
    WS_URL = 'wss://yun.seagull-flyingcar.com/haiou-feiche/websocket/data_analysis/info'
    FLV_URL = 'https://yun.seagull-flyingcar.com/live?port=1999&app=liveapp&stream=test&token='
} else {
    BASE_URL = ''
}

export { BASE_URL, TIMEOUT, WS_URL, FLV_URL }